/* Image protection: blocks right-click save and dragging on photos. Screenshots can't be blocked. */
(function () {
  function onPhoto(t) {
    return t && t.closest && t.closest('img, picture, video, .gal__item, .card__media, .tile__media, [data-protect]');
  }
  document.addEventListener('contextmenu', function (e) { if (onPhoto(e.target)) e.preventDefault(); }, true);
  document.addEventListener('dragstart', function (e) { if (onPhoto(e.target)) e.preventDefault(); }, true);
})();
